(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jf-gift-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.jfGiftAddInitialized) {
    window.jfGiftAddInitialized = true;
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.jf-gifts__form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('.jf-gifts__add');
      if (!button || button.disabled) return;
      button.disabled = true;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData(form);
      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((item) => item.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'cart-add-failed');
        if (cart) cart.renderContents(result);
        else window.location = window.routes.cart_url;
      } catch (error) {
        HTMLFormElement.prototype.submit.call(form);
      } finally {
        button.disabled = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jf-grouped-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.jf-grouped__form');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('.jf-grouped__add');
    if (!button || button.disabled) return;

    const defaultLabel = button.dataset.defaultLabel;
    button.disabled = true;

    try {
      const response = await fetch(`${form.action}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error('cart-add-failed');
      button.textContent = button.dataset.addedLabel;
      button.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      window.setTimeout(() => {
        button.textContent = defaultLabel;
        button.classList.remove('is-added');
        button.disabled = false;
      }, 1600);
    } catch (error) {
      button.disabled = false;
      HTMLFormElement.prototype.submit.call(form);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
